import Projection from "../../Projection";
import { Settings } from "../../Settings";
import Character from "../character/Character";
import { CharacterAction } from "../character/CharacterAction";
import Grid from "../grid/Grid";
import GridInversionOfControl from "../grid/GridInversionOfControl";
import WorldGrid from "../grid/WorldGrid";
import GameTime from "../time/GameTime";
import Collision from "./Collision";

export default class CharacterPhysics {
    /**
     * @param {WorldGrid} worldGrid
     * @param {Projection} projection 
     * @param {GameTime} gameTime
     */
    constructor(worldGrid, projection, gameTime) {

        /**
         * @constant
         * @type {WorldGrid}
         */
        this.worldGrid = worldGrid;

        /**
         * @constant
         * @type {Projection}
         */
        this.projection = projection;

        /**
         * @constant
         * @private
         * @type {Collision}
         */
        this.collision = new Collision();

        /**
         * @constant
         * @type {GameTime}
         */
        this.gameTime = gameTime;


        const thisRef = this;

        /**
         * @type {number}
         */
        this.frameTimeRatio = 1;


        // The y-coordinate math is buggy. characters fall past the tile and then get pushed back up.  origin is top left corner.

        /**
         * @constant
         * @private
         * @type {Function}
         */
        this.applyForcesOnCharactersFunction = 
            /**
             * @param {Grid} grid 
             */
            function(grid) {
                // Moving characters can push them out of their grid. Lets iterate in reverse order
                for (let i = grid.characters.length - 1; i >= 0; i--) {
                    const character = grid.characters[i];
                    // Only apply physics on the character if they are not following a path, and
                    // they did not move in the current frame.

                    // Do not apply physics to the party members.
                    if (character.isPartyMember()) {
                        continue;
                    }

                    // Strange things can happen if you pan the canvas far away from the main character. Their tile gets recycled
                    // into the current part of the world.
                    if (!character.position.tile) {
                        continue;
                    }

                    // If the character has a path, then no gravity will ever be applied.
                    if (character.position.pathPlan.length > 0) {
                        continue;                            
                    }

                    thisRef.applyGravity(character, thisRef.frameTimeRatio);
                }
            };
    }

    /**
     * @param {number} frameTimeRatio 
     */
    updatePhysicsForFrame(frameTimeRatio) {

        this.frameTimeRatio = frameTimeRatio;

        GridInversionOfControl.allVisibleGrids(this.worldGrid, this.projection, this.applyForcesOnCharactersFunction);
    }

    /**
     * @private
     * @param {Character} character 
     * @param {number} frameTimeRatio 
     */
    applyGravity(character, frameTimeRatio) {
        // Don't apply gravity if we are standing on something.
        if (Collision.isStandingOnTopOfClosedTile(character)) {
            // Make sure we're standing right on the tile origin.
            character.position.setPositionToTileOrigin();

            if (character.position.gravityThisFrame > 0) {
                character.position.gravityThisFrame = 0;
                character.setCharacterAction(CharacterAction.STAND);
            }
            return;
        }

        character.position.gravityThisFrame = Settings.physics.gravityRatePerFrame * frameTimeRatio;
        
        // See if we are still falling.
        if (!this.collision.isCollisionDown(character, character.position.gravityThisFrame)) {
            character.position.moveY(character.position.gravityThisFrame); // increasing y pushes the character down.
            character.setCharacterAction(CharacterAction.FALL);

            // TODO we can see the character fall through the floor and then get reset. this sucks.
            // lets make falling be a character behavior that is connected to tiles. You fall for X tiles.

        }
        else {
            // We're done falling, make sure we are standing right on the tile origin.
            character.position.setPositionToTileOrigin();
            if (character.position.gravityThisFrame > 0) {
                character.position.gravityThisFrame = 0;
                character.setCharacterAction(CharacterAction.STAND);
            }
        }
    }

}